module.exports = {
    default: {
        pageSize: 25,
        showActiveMaterials: true,
        showPricing: false
    },
    config: {
        adHocGroup: 5090,
        pages: [25, 50, 100, 200, 500]
    }
}